<template>
  <div class="row">
    <div v-for="game in gameItems" class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-3">
      <soidown-item
        :id="game.id"
        :status="game.status"
        :game-slug="game.master.slug"
        :close-at="game.display_closed_at"
        :title="game.name ? game.name + ' ' + game.readable_edition : game.master.name + ' ' + game.readable_edition"
        :readable-edition="game.readable_edition"
        :seconds-left="game.diff_in_seconds > 0 ? (game.status == 'open' ? game.diff_in_seconds : 0) : 0"
        :game-link="slug != '' ? `../../lotto/` + game.id : `./lotto/` + game.id"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'IndexLotto',
  props: {
    slug: { type: String, default: '' },
  },
  data() {
    return {
      gameItems: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    if (this.slug == '') {
      axios.get('/api/game/latest').then((res) => {
        this.gameItems = res.data;
      });
    } else {
      axios.get(`/api/game/getGame/${this.slug}`).then((res) => {
        this.gameItems = res.data;
      });
    }
  },
  mounted() {},
  methods: {},
};
</script>
